<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table
  #pt
  [value]="occMatrixs"
  [lazy]="true"
  (onLazyLoad)="loadLazy($event)"
  dataKey="occMatrixId"
  selectionMode="single"
  [(selection)]="occMatrix"
  (onRowSelect)="onRowSelect($event)"
  [loading]="loading"

  [paginator]="showPagination"
  [rows]="200"
  [rowsPerPageOptions]="[200, 500, 1000]"
  showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
  [totalRecords]="recordTotal"

  sortMode="multiple"
  [multiSortMeta]="multiSortMeta"

  styleClass="p-datatable-sm p-datatable-striped"

  [scrollable]="true"
  scrollDirection="both"
  scrollHeight="flex"

  [resizableColumns]="true"
  >

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">OccMatrixs</h1>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        @if (!outlineNewButton) {
          <button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New OccMatrix +</button>
        }
        @if (outlineNewButton) {
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New OccMatrix +</button>
        }
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [style.width]="col.width">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'occMatrixId', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'occMapVO.name', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'daysToArrivalTo', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'daysToArrivalFrom', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'expNominalOccToDatePct', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'seasonCode', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'minStayExpectedNTS', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermGapMultiplierPCT', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermGapMinNumNightsRevNTS', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'longTermGapMultiplierPCT', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'longTermGapEmptyMultiplierPCT', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'connectingFrontOrBackMultiplierPCT', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'connectingFrontAndBackMultiplierPCT', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-occMatrix>
    <tr [pSelectableRow]="occMatrix">
      <td>{{occMatrix.occMatrixId}} </td>
      <td>{{occMatrix.occMapName}}</td>
      <td>{{occMatrix.daysToArrivalTo}}</td>
      <td>{{occMatrix.daysToArrivalFrom}}</td>
      <td>{{ occMatrix.expNominalOccToDatePct * 100 | number:'1.0-0' }}%</td>
      <td>{{occMatrix.seasonCode}}</td>
      <td>{{ occMatrix.minStayExpectedNTS }}</td>
      <td>
        {{ occMatrix.shortTermGapMultiplierPCT != null
        ? (occMatrix.shortTermGapMultiplierPCT * 100 | number:'1.0-0') + '%'
        : '' }}
      </td>

      <td>{{ occMatrix.shortTermGapMinNumNightsRevNTS }}</td>

      <td>
        {{ occMatrix.longTermGapMultiplierPCT != null
        ? (occMatrix.longTermGapMultiplierPCT * 100 | number:'1.0-0') + '%'
        : '' }}
      </td>

      <td>
        {{ occMatrix.longTermGapEmptyMultiplierPCT != null
        ? (occMatrix.longTermGapEmptyMultiplierPCT * 100 | number:'1.0-0') + '%'
        : '' }}
      </td>

      <td>
        {{ occMatrix.connectingFrontOrBackMultiplierPCT != null
        ? (occMatrix.connectingFrontOrBackMultiplierPCT * 100 | number:'1.0-0') + '%'
        : '' }}
      </td>

      <td>
        {{ occMatrix.connectingFrontAndBackMultiplierPCT != null
        ? (occMatrix.connectingFrontAndBackMultiplierPCT * 100 | number:'1.0-0') + '%'
        : '' }}
      </td>
      <td><span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true"
          style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(occMatrix)"></i>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>